<template>
  <mep-type is="h3" class="py-6" variant="feature-large">Who do you need to protect?</mep-type>
  <div class="grid h-[483px] grid-cols-2 gap-2 py-2">
    <mep-icon-toggle-button
      v-for="option in mepRef15Options"
      :key="option"
      :label="mepRef15OptionsLabels[option]"
      :icon="mepRef15OptionsIcons[option]"
      :is-checked="isOptionSelected(option)"
      @toggle="toggleOption(option)"
    />
  </div>
</template>

<script setup lang="ts">
import {
  MyEmergencyPlanFormSchema,
  MyEmergencyPlanStageComponent,
  mepRef15Options,
  mepRef15OptionsIcons,
  myEmergencyPlanFormSchema,
  ref16TrueValues,
  mepRef15OptionsLabels,
} from '@/features';
import { useMyEmergencyPlanStore } from '@/features/my-emergency-plan/presentation/bloc/my-emergency-plan-bloc';
import { storeToRefs } from 'pinia';
import { watch } from 'vue';

const myEmergencyPlanStore = useMyEmergencyPlanStore();
const { nextStageId, isStageValid } = storeToRefs(myEmergencyPlanStore);

const {
  form: { defineField },
} = myEmergencyPlanStore;

const [ref15] = defineField('ref15');

const isOptionSelected = (option: MyEmergencyPlanFormSchema['ref15'][number]) => {
  return ref15.value?.includes(option as MyEmergencyPlanFormSchema['ref15'][number]) || false;
};

function toggleOption(option: MyEmergencyPlanFormSchema['ref15'][number]) {
  if (!ref15.value) {
    ref15.value = [];
  }
  const index = ref15.value.indexOf(option);
  if (index === -1) {
    ref15.value.push(option);
  } else {
    ref15.value.splice(index, 1);
  }
}

watch(
  () => ref15.value,
  () => {
    isStageValid.value = myEmergencyPlanFormSchema.shape.ref15.safeParse(ref15.value).success;

    if (ref15.value?.some((value) => ref16TrueValues.includes(value))) {
      nextStageId.value = 'REF17';
    } else {
      nextStageId.value = 'G4';
    }
  },
  { immediate: true, deep: true }
);

const onPrimaryButtonClicked = () => {
  myEmergencyPlanStore.nextStage();
};

defineExpose<MyEmergencyPlanStageComponent>({
  onPrimaryButtonClicked,
});
</script>
